import { render, staticRenderFns } from "./Shipments.vue?vue&type=template&id=a7d71146&scoped=true"
import script from "./Shipments.vue?vue&type=script&lang=js"
export * from "./Shipments.vue?vue&type=script&lang=js"
import style0 from "./Shipments.vue?vue&type=style&index=0&id=a7d71146&prod&scoped=true&lang=css"
import style1 from "./Shipments.vue?vue&type=style&index=1&id=a7d71146&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7d71146",
  null
  
)

export default component.exports